import { Link, useLocation } from "react-router-dom";
import { iconMap } from "../../components/IconMap";
import type { Props } from "../Sidebar";



export const MobileNav: React.FC<Props> = ({ data }) => {
    const location = useLocation();

    return (
        <nav className="flex justify-around items-center p-2 mb-2 glass-nav border mx-2 rounded-xl border-primary z-[120]">
            {data.map((item) => {
                const isActive = location.pathname === item.route;

                return (
                    <Link
                        key={item.route}
                        to={item.route}
                        className={`
                    flex flex-col items-center gap-1 text-sm transition
                    ${isActive ? "text-blue-600 font-medium" : "text-gray-700"}
                    `}
                    >
                        <span>{iconMap[item.icon]}</span>
                        <span>{item.name}</span>
                    </Link>
                );
            })}
        </nav>
    );
}
